import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { removeFromStorage } from "../utils/webStorage";

const SaloonWorldLayout = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    removeFromStorage("accessToken");
    removeFromStorage("refreshToken");
    removeFromStorage("roles");
    removeFromStorage("user");
    removeFromStorage("googleAccessToken");
    removeFromStorage("googleRefreshToken");
    window.location.reload();
    navigate("/login");
  };
  return (
    <div className="bg-bgColor-primary">
      <div className="flex flex-col flex-1 min-h-screen">
        <div className="sticky top-0 z-20 flex-shrink-0 flex bg-saloon-primary p-4 rounded-xl h-20">
          <div className="flex-1 pr-4 flex justify-between">
            <NavLink className="m-auto md:w-56" to="/">
              <img
                className="max-h-12 w-auto"
                src="/saloonworld-logo.svg"
                alt="logo"
              />
            </NavLink>
            <div className="flex-1 flex">
              <NavLink
                to="/calls"
                className="hidden md:block h-11 w-auto my-auto mx-3"
              ></NavLink>
              <div className="flex ml-auto">
                <button
                  className="block w-full text-left px-12 py-1 text-sm text-saloon-primary bg-saloon-btn hover:bg-opacity-80 rounded-3xl"
                  onClick={handleLogout}
                  type="button"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>

        <main className="container mx-auto h-full md:min-h-[calc(100vh-6rem)]">
          <div className="md:ml-4 xl:ml-5 px-5 py-4">
            <div className="flex flex-wrap my-5 items-center">
              <div className="flex flex-row items-center">
                <img src="/assets/saloon/home.svg" alt="home" />
                <span className="text-lg md:text-2xl font-semibold mx-5">
                  Home
                </span>
              </div>
              <div className="ml-auto">
				<div className="bg-saloon-primary px-5 py-2 rounded-2xl font-medium text-sm">
					Subscribed
				</div>
			  </div>
            </div>
            <div className="w-full flex flex-wrap py-3 -mx-2 border-b">
              <NavLink
                to={"payments"}
                className="px-2 py-1 border border-primary-dark rounded-2xl m-2"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                })}
              >
                Billing Details
              </NavLink>
              <NavLink
                to={"calls"}
                className="px-2 py-1 border border-primary-dark rounded-2xl font-medium m-2"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                })}
              >
                Call Details
              </NavLink>
              <NavLink
                to={"statistics"}
                className="px-2 py-1 border border-primary-dark rounded-2xl font-medium m-2"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                })}
              >
                Call Statistics
              </NavLink>
              <NavLink
                to={"invoices"}
                className="px-2 py-1 border border-primary-dark rounded-2xl font-medium m-2"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                })}
              >
                Invoice Payment
              </NavLink>
            </div>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default SaloonWorldLayout;
